module.exports = __webpack_public_path__ + "img/Elven_Hammer_01.8c22f221.png";